import React from 'react';
import { cn } from '../../lib/utils';

/*
 * Infinite marquee. Adapted from Magic UI "Marquee" (MIT) via 21st.dev:
 * https://21st.dev/dillionverma/marquee — keyframes live in tailwind.config.js.
 * Set --duration / --gap through className, e.g. "[--duration:60s] [--gap:3rem]".
 * `paused` holds the rails in place (e.g. while off-screen).
 */
const Marquee = ({ className, reverse = false, pauseOnHover = false, vertical = false, paused = false, repeat = 4, children, ...props }) => (
  <div
    {...props}
    className={cn(
      'group flex overflow-hidden [--duration:40s] [--gap:1rem] [gap:var(--gap)]',
      vertical ? 'flex-col' : 'flex-row',
      className
    )}
  >
    {Array.from({ length: repeat }, (_, i) => (
      <div
        key={i}
        aria-hidden={i > 0 ? 'true' : undefined}
        className={cn(
          'flex shrink-0 justify-around [gap:var(--gap)] motion-reduce:[animation-play-state:paused]',
          vertical ? 'animate-marquee-vertical flex-col' : 'animate-marquee flex-row',
          pauseOnHover && 'group-hover:[animation-play-state:paused]',
          paused && '[animation-play-state:paused]',
          reverse && '[animation-direction:reverse]'
        )}
      >
        {children}
      </div>
    ))}
  </div>
);

export default Marquee;
